import { Button, Modal as BootstrapModal } from 'react-bootstrap';
import { useState, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import TextBox from '../../../../controls/form/TextBox';
import Dropdown from '../../../../controls/form/Dropdown';

const CreatePageModal = ({ show, onCreate, onCancel, layouts, }) => {
    const [name, setName] = useState('');
    const [route, setRoute] = useState('');
    const [translate] = useTranslation();

    const onBlurPageName = useCallback((event) => {
        setName(event.target.value);

        if (!route) {
            setRoute(`/${event.target.value}`);
        }
    }, [route]);

    const create = useCallback((values) => {
        onCreate(values);
    }, [onCreate]);

    const renderForm = useMemo(() => {
        return (
            <Formik initialValues={{
                name: name,
                route: route,
                layout: layouts[0]?._id,
            }} validationSchema={Yup.object({
                name: Yup.string().required(' ')
            })} onSubmit={create} enableReinitialize>
                <Form>
                    <BootstrapModal.Header className='h5 text-secondary'>
                        {translate('OTM_CREATE_PAGE')}
                    </BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <TextBox
                            label={translate('OTM_NAME')}
                            type='text'
                            name='name'
                            onBlur={onBlurPageName}
                        />
                        <TextBox
                            label={translate('OTM_ROUTE')}
                            type='text'
                            name='route'
                            css='mt-3'
                            onChange={(event) => setRoute(event.target.value)}
                        />
                        <div className='mt-3'>
                            <Dropdown
                                name='layout'
                                options={layouts}
                                heading={translate('OTM_LAYOUT')}
                                grow={true}
                            />
                        </div>
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button disabled={name === ''} type='submit' className='btn-sm'>{translate('OTM_CREATE')}</Button>
                        <Button onClick={onCancel} variant='secondary' className='btn-sm'>{translate('OTM_CANCEL')}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        )
    }, [translate, create, onCancel, name, route, layouts, onBlurPageName]);

    return (
        <BootstrapModal show={show} backdrop='static'>
            {renderForm}
        </BootstrapModal>
    );
};

export default CreatePageModal;
